import React, { useState } from 'react'
import QRCode from "qrcode.react";

export const QrCode = ({ upiDetails, totalAmount }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!upiDetails || upiDetails === 'UPI not set') {
    return null;
  }

  const qrValue = `upi://pay?pa=${upiDetails}&am=${totalAmount}`;

  return (
    <>
      <div className="text-center">
        <p className="font-bold mb-2">Scan the QR code to pay ₹{totalAmount}</p>
        <div 
          className="flex justify-center items-center my-3 cursor-pointer hover:opacity-80 transition-opacity"
          onClick={() => setIsModalOpen(true)}
          title="Click to enlarge QR Code"
        >
          <div className="relative group">
            <QRCode value={qrValue} size={98} renderAs="svg" />
            <div className="absolute inset-0 bg-black bg-opacity-10 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity rounded">
              <span className="text-xs bg-white text-gray-800 px-2 py-1 rounded shadow">Enlarge</span>
            </div>
          </div>
        </div>
        <button
          onClick={() => setIsModalOpen(true)}
          className="text-xs font-semibold text-teal-600 hover:text-teal-800 underline underline-offset-2 flex items-center justify-center w-full gap-1"
        >
          <span>⤢</span> Click to Enlarge QR
        </button>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-8 relative flex flex-col items-center animate-fadeIn">
            <button 
              onClick={() => setIsModalOpen(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-800 transition-colors w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 font-bold"
            >
              ✕
            </button>
            <h2 className="text-xl font-bold text-gray-800 mb-6 text-center w-full">
              Pay ₹{totalAmount}
            </h2>
            <div className="bg-white p-4 rounded-xl shadow-inner border border-gray-100">
              <QRCode value={qrValue} size={250} renderAs="svg" />
            </div>
            <p className="text-sm text-gray-500 mt-6 text-center">
              Scan with any UPI app
              <br/>
              <span className="font-semibold text-gray-700">{upiDetails}</span>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

